import { Component, OnInit, Inject, ViewChild, ElementRef, AfterViewInit, } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject, Observable } from 'rxjs';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { MatSnackBar } from '@angular/material/snack-bar';

import { FileManagerService } from '../../file-manager.service';

@Component({
  standalone: false,
  selector: 'app-file-camera-upload',
  templateUrl: './file-camera-upload.component.html',
  styleUrls: ['./file-camera-upload.component.css']
})
export class FileCameraUploadComponent implements OnInit, AfterViewInit {

  @ViewChild("canvas") public canvas: ElementRef;
  @ViewChild("webcamContainer") public webcamContainer: ElementRef;

  multipleWebcamsAvailable = false;

  captureImageObs: Subject<void> = new Subject<void>();
  nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();

  minimizeCamera: boolean = false;
  webcamImage: WebcamImage = null;

  disableSnapButton: boolean = false;

  patientId: string;

  canvasTimeout: any;

  videoWidth: number = 640;
  videoHeight: number = 480;

  constructor(
    private fileManagerService: FileManagerService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<FileCameraUploadComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.patientId = this.data.patientId;
    
    //this.init();
  }

  ngAfterViewInit() {
    console.log("webcamContainer", this.webcamContainer);
    this.videoWidth = this.webcamContainer.nativeElement.offsetWidth;
    this.videoHeight = this.webcamContainer.nativeElement.offsetHeight;
    console.log("Video dimensions", this.videoWidth, this.videoHeight);
  }
  init() {
    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
      });
  }

  handleInitError(e) {
    console.log('ERROR there was an error getting the webcam');
  }

  capturePhotoEvent() {
    this.captureImageObs.next();
  }

  convertImageToCanvas(image: WebcamImage) {

    //imageAsDataUrl

    this.disableSnapButton = true;

    var snap = image.imageAsBase64;
    this.onSnapTaken(snap);

    //var context = this.canvas.nativeElement.getContext("2d")
    //var img = new Image;
    //img.onload = () => {
    //  context.drawImage(img, 0, 0);
    //};
    ////img.src = imageURI;
    //img.src = 'https://www.w3schools.com/tags/img_the_scream.jpg';
    //var snap = this.canvas.nativeElement.toDataURL("image/png");
    //this.onSnapTaken(snap);





    if (this.canvasTimeout) {
      clearTimeout(this.canvasTimeout);
      this.canvasTimeout = false;
    }

    this.canvasTimeout = setTimeout(_ => {
    this.minimizeCamera = false;
    this.disableSnapButton = false;
    }, 500);
  }

  onSnapTaken(snap) {
    var obj = {
      src: snap,
      saved: false,
      createdOn: new Date(),
    };

    this.saveSnapshot(obj);
  }

  saveSnapshot(capture: any) {
    /*var blob = this.base64ToBlob(capture.src, 'image/png');

    this.fileManagerService.uploadDocuments(blob, this.patientId)
      .subscribe(response => {
        this.showSnackbar(false, 'Import complete', 5000);
        capture.saved = true;
      }, err => {
        console.log(err);
        this.showSnackbar(true, 'Error importing image', 5000);
      });*/
  }

  showSnackbar(error: boolean, message: string, duration: number = 5000) {
    this.snackBar.open(message, error ? 'Error' : 'Success', { duration: 5 * 1000, verticalPosition: "top" });
  }

  base64ToBlob(base64: string, mime: string) {

    base64 = base64.replace(`data:${mime};base64,`, '');
    mime = mime || '';
    var sliceSize = 1024;
    var byteChars = atob(base64);
    var byteArrays = [];

    for (var offset = 0, len = byteChars.length; offset < len; offset += sliceSize) {
      var slice = byteChars.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: mime });
  }

  handleImage(webcamImage: WebcamImage) {
    console.log('received webcam image', webcamImage);
    this.webcamImage = webcamImage;

    this.minimizeCamera = true;

    this.convertImageToCanvas(this.webcamImage);
  }

  showNextWebcam(directionOrDeviceId: boolean | string): void {
    this.nextWebcam.next(directionOrDeviceId);
  }

  close() {
    if(this.webcamImage)
      this.dialogRef.close(this.base64ToBlob(this.webcamImage.imageAsBase64, 'image/jpeg'));
    else
    this.dialogRef.close();
  }

  get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }

}
